import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { UsuarioDropDown } from "../../../../../common/domain/models/usuario_dropdown";

/**
 * useGedRhFilter
 */

type State = {
  tipoPesquisa: number;
  valueField: string;
  status: number;
  usuariosDropdown: UsuarioDropDown[] | undefined;
};

type Actions = {
  setTipoPesquisa: SetFunction<number>;
  setValueField: SetFunction<string>;
  setStatus: SetFunction<number>;
  setUsuariosDropdown: SetFunction<UsuarioDropDown[]>;
  clearFilters: () => void;
};

export const initialGedRhFilterState: Partial<State> = {
  tipoPesquisa: 2,
  valueField: "",
  status: 2,
}

export const useGedRhFilter = create<State & Actions>((set) => ({
  tipoPesquisa: 2,
  valueField: "",
  status: 2,
  usuariosDropdown: undefined,
  setTipoPesquisa: vfn => SetFunctionImpl(set, 'tipoPesquisa', vfn),
  setValueField: vfn => SetFunctionImpl(set, 'valueField', vfn),
  setStatus: vfn => SetFunctionImpl(set, 'status', vfn),
  setUsuariosDropdown: vfn => SetFunctionImpl(set, 'usuariosDropdown', vfn),
  clearFilters: () => set({ ...initialGedRhFilterState }),
}));